import { lazy } from "react";
import { RoleRoute } from "../../app/router";

const Dashboard             = lazy(() => import("./pages/ApprenantDashboard"));
const MesFormations         = lazy(() => import("./pages/MesFormations"));
const FormationDetail       = lazy(() => import("./pages/FormationDetail"));
const ModuleDetail          = lazy(() => import("./pages/ModuleDetail"));
const MesCertificats        = lazy(() => import("./pages/MesCertificats"));
const Certificat            = lazy(() => import("./pages/Apprenantcertificat"));
const Profile               = lazy(() => import("./pages/ApprenantProfile"));
const InscriptionFormation  = lazy(() => import("./pages/InscriptionFormation"));
const ChatPage              = lazy(() => import("./pages/ChatPage"));
const Messagerie            = lazy(() => import("./pages/Messagerie"));

const wrap = (el) => <RoleRoute role="apprenant">{el}</RoleRoute>;

export const apprenantRoutes = [
  { path: "/apprenant",                                    element: wrap(<Dashboard />) },
  { path: "/apprenant/dashboard",                          element: wrap(<Dashboard />) },
  { path: "/apprenant/formations",                         element: wrap(<MesFormations />) },
  { path: "/apprenant/formations/:id",                     element: wrap(<FormationDetail />) },
  { path: "/apprenant/formations/:formationId/modules/:moduleId", element: wrap(<ModuleDetail />) },
  { path: "/apprenant/certificats",                        element: wrap(<MesCertificats />) },
  { path: "/apprenant/profile",                            element: wrap(<Profile />) },
  { path: "/apprenant/inscrire",                           element: wrap(<InscriptionFormation />) },
  { path: "/apprenant/chat",                               element: <ChatPage /> },
  { path: "/apprenant/Messagerie",                         element: wrap(<Messagerie />) },
  { path: "/apprenant/formations/:id/certificat",           element: <Certificat /> },
];
